<template>
  <div class="validation">
    <!-- <div class="validation-photo overflow-hidden">
      <img
        v-if="repair.vehicle?.gallery?.length > 0"
        :src="repair.vehicle?.gallery[0]"
        class="avatar rounded-circle mr-3"
      />
      <span
        class="default-icon d-flex h-100 w-100 justify-content-center align-items-center bg-lighter"
        v-else
      >
        <i class="far fa-camera fa-3x"></i>
      </span>
    </div> -->
    <repair-view-global :repair="repair" :show-buttons="false" />
  </div>
</template>

<script>
import RepairViewGlobal from "./RepairViewGlobal.vue";

export default {
  name: "repair-form-validation-step",

  components: { RepairViewGlobal },

  mixins: [],

  props: {
    repairData: { type: Object },
  },

  data() {
    const repair = { ...this.repairData };
    return {
      repair,
    };
  },

  watch: {
    repairData: {
      handler: function (value) {
        this.repair = { ...this.repair, ...value };
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
